module.exports = __webpack_public_path__ + "img/pci.0be940b1.svg";